import * as React from "react";
import { useLocation } from "react-router-dom";
import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
// Temporarily disabled to figure out regression in UPLT in MILLION_LINT_OPTIMIZATION_241118
var getSettingAndAssignMillionLintOptimizationUseLocation = function() {
    return false;
};
var useRawZustandLocation = create(function() {
    return {
        search: "",
        pathname: "",
        hash: "",
        state: null,
        key: ""
    };
});
export var useZustandLocation = function(selector) {
    var shouldMemoMillionLint = getSettingAndAssignMillionLintOptimizationUseLocation() && // eslint-disable-next-line no-process-env
    "production" !== "test";
    if (shouldMemoMillionLint) {
        // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
        useRawZustandLocation(useShallow(selector));
    }
    return shouldMemoMillionLint ? useRawZustandLocation.getState() : useLocation();
};
export var ZustandLocationProvider = function() {
    var location = useLocation();
    React.useEffect(function() {
        useRawZustandLocation.setState(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        location.pathname,
        location.key,
        location.hash,
        location.state
    ]);
    return null;
};
